import bounceApiClient from '../common/utils/bounceApiClient';
import { GetActiveFeaturesDto } from './types';
import { GenericSuccessResponse } from '../common/types/response';

export async function getFeatures(): Promise<GetActiveFeaturesDto> {
  const { data } = await bounceApiClient.get(`/api/features`);

  return data;
}

export async function viewFeatureReminder({
  featureId,
  screenName
}: {
  featureId: string;
  screenName: string;
}): Promise<GenericSuccessResponse> {
  const { data } = await bounceApiClient.put(
    `/api/features/${featureId}/viewReminder`,
    {
      screenName
    }
  );

  return data;
}
